<template>
  <div class="section-view" :style="getBackgroundStyle()">
    <div :id="sectionID">
      <div :id="sectionID + '_s' + i.toString()" class="widget-container" v-for="(w, i) in section.widgets" :key="'widget'+i.toString()" :style="getWidgetShellStyle(w, afterTransition)" :windex="i">
        <div v-on:mousedown="dragStart" :style="'opacity:' + getWidgetProperty(w, 'opacity', afterTransition) + ';'">
          <textwidget v-if="w.type == WidgetUtils.WidgetTypes.TEXT" :content="w.properties.text" :color="w.properties.color" :font="w.properties.font" :letterspacing="w.properties.letterSpacing" :lineheight="w.properties.lineHeight" :size="GeneralUtils.isMobile() && w.properties.msize != undefined ? w.properties.msize : w.properties.size" :align="w.properties.alignment"></textwidget>
          <imagewidget v-if="w.type == WidgetUtils.WidgetTypes.IMAGE"  :content="w.properties.src"></imagewidget>
          <!-- <guagewidget v-if="w.type == WidgetUtils.WidgetTypes.GUAGE" :chartdata="w.chartdata" :colors="w.colors" :textcolor="w.properties.color" :title="w.properties.text" sig="guage1"></guagewidget>
          <piewidget v-if="w.type == WidgetUtils.WidgetTypes.PIE" :chartdata="w.chartdata" :colors="w.colors" :textcolor="w.properties.color" :title="w.properties.text" :hovertitle="w.properties.text" sig="pie1" :legend="w.properties.legend"></piewidget> -->
          <!-- <pixiticker v-if="w.type == 'ticker'" :properties="w.properties"></pixiticker> -->
          <blockwidget v-if="w.type == WidgetUtils.WidgetTypes.BLOCK" :color="w.properties.color"></blockwidget>
          <svgticker v-if="w.type == WidgetUtils.WidgetTypes.TICKER" :color="w.properties.color" :val="w.properties.val" :width="w.properties.width"></svgticker>
          <jsappwidget v-if="w.type == WidgetUtils.WidgetTypes.JS_APP" :script="w.properties.script" :extras="w.properties.extras"></jsappwidget>
          <iframewidget v-if="w.type == WidgetUtils.WidgetTypes.IFRAME"  :content="w.properties.url"></iframewidget>
          <div class="editor-drag-overlay"></div>
        </div>
        <div v-on:mousedown="sizeStart" class="widget-sizer"></div>
      </div>
    </div>
    <div v-if="s.shared && !section.shared" v-for="(s, j) in sections" :key="'section'+j.toString()">
      <div :id="sectionID + '_d' + i.toString()" class="widget-container" v-for="(w, i) in sections[j].widgets" :key="'widget'+i.toString()" :style="getWidgetShellStyle(w, afterTransition, index)" :sindex="j" :windex="i">
        <div v-on:mousedown="dragStart" :style="'opacity:' + getWidgetProperty(w, 'opacity', afterTransition, index) + ';'">
          <textwidget v-if="w.type == WidgetUtils.WidgetTypes.TEXT" :content="w.properties.text" :color="w.properties.color" :font="w.properties.font" :letterspacing="w.properties.letterSpacing" :lineheight="w.properties.lineHeight" :size="GeneralUtils.isMobile() && w.properties.msize != undefined ? w.properties.msize : w.properties.size" :align="w.properties.alignment"></textwidget>
          <imagewidget v-if="w.type == WidgetUtils.WidgetTypes.IMAGE"  :content="w.properties.src"></imagewidget>
          <!-- <guagewidget v-if="w.type == WidgetUtils.WidgetTypes.GUAGE" :chartdata="w.chartdata" :colors="w.colors" :textcolor="w.properties.color" :title="w.properties.text" sig="guage1"></guagewidget> -->
          <!-- <piewidget v-if="w.type == WidgetUtils.WidgetTypes.PIE" :chartdata="w.chartdata" :colors="w.colors" :textcolor="w.properties.color" :title="w.properties.text" :hovertitle="w.properties.text" sig="pie1" :legend="w.properties.legend"></piewidget> -->
          <blockwidget v-if="w.type == WidgetUtils.WidgetTypes.BLOCK" :color="w.properties.color"></blockwidget>
          <svgticker v-if="w.type == WidgetUtils.WidgetTypes.TICKER" :color="w.properties.color" :val="w.properties.val" :width="w.properties.width"></svgticker>
          <jsappwidget v-if="w.type == WidgetUtils.WidgetTypes.JS_APP" :script="w.properties.script" :extras="w.properties.extras"></jsappwidget>
          <iframewidget v-if="w.type == WidgetUtils.WidgetTypes.IFRAME"  :content="w.properties.url"></iframewidget>
          <div class="editor-drag-overlay"></div>
        </div>
        <div v-on:mousedown="sizeStart" class="widget-sizer"></div>
      </div>
    </div>
    <div class="section-details">
      <input type="text" v-model="section.background.color">
      <input type="text" v-model="section.background.image.url">
      <input type="text" v-model="section.background.image.size">
      <input type="text" v-model="section.background.image.repeat">
      <input type="text" v-model="section.background.image.position">
      <propertyeditor v-if="selectedSidgetIndex >= 0" :widget="selectedWidget" :index="index" :section="section" :parent="parentSection"></propertyeditor>
    </div>
    <span class="util-nav">
      <button v-on:click="addWidgetClicked">Add Widget</button>
      <label class="after-toggle"><input type="checkbox" v-model="afterTransition" /> After Animation</label>
      <button v-on:click="saveClicked">Save</button>
    </span>
    <mwin :sig="GeneralUtils.Modals.ADD_WIDGET" :cancelable="true" v-if="showAddWindow">
      <div slot="content">
        <select v-model="selectedType">
          <option v-for="(w, i) in WidgetUtils.WidgetTypes" :key="'type'+i.toString()" :value="w">
            {{w}}
          </option>
        </select>
      </div>
    </mwin>
    <!-- <div v-if="showAddWindow" class="add-widget-contol">
      <div>
        <select v-model="selectedType">
          <option v-for="(w, i) in WidgetUtils.WidgetTypes" :key="'type'+i.toString()" :value="w">
            {{w}}
          </option>
        </select>
        <div>
          <button v-on:click="showAddWindow = false">Cancel</button>
          <button v-on:click="addWidgetConfirmed()">Add</button>
        </div>
      </div>
    </div> -->
    <div v-if="dragProps.active || sizeProps.active" v-on:mouseup="dragEnd" v-on:mousemove="dragMove" style="position:fixed;top:0;left:0;right:0;bottom:0;z-index:200;background-color:rgba(0,0,0,.2);width:auto;height:auto;"></div>
  </div>
</template>
<script>
// import WidgetUtils from './utils/WidgetUtils.js'
import {EventBus} from '../utils/EventBus.js'
import TextWidget from '../widgets/TextWidget.vue'
import ImageWidget from '../widgets/ImageWidget.vue'
// import GuageWidget from '../widgets/GuageWidget.vue'
import PieWidget from '../widgets/PieWidget.vue'
import IFrameWidget from '../widgets/IFrameWidget.vue'
// import PixiTicker from './widgets/PixiTicker.vue'
import BlockWidget from '../widgets/BlockWidget.vue'
import SVGTicker from '../widgets/SVGTicker.vue'
import JSAppWidget from '../widgets/JSAppWidget.vue'
import PropertyEditor from './PropertyEditor.vue'
import WidgetUtils from '../utils/WidgetUtils.js'
import GeneralUtils from '../utils/GeneralUtils.js'
import ModalWindow from './ModalWindow.vue'
export default {
  components: {
    textwidget: TextWidget,
    imagewidget: ImageWidget,
    // guagewidget: GuageWidget,
    // piewidget: PieWidget,
    iframewidget: IFrameWidget,
    // pixiticker: PixiTicker,
    blockwidget: BlockWidget,
    // svgticker: SVGTicker,
    jsappwidget: JSAppWidget,
    propertyeditor: PropertyEditor,
    mwin: ModalWindow
  },
  props: ['section', 'sections', 'index'],
  data () {
    return {
      afterTransition: true,
      selectedWidget: null,
      selectedSidgetIndex: -1,
      WidgetUtils: WidgetUtils,
      GeneralUtils: GeneralUtils,
      showAddWindow: false,
      selectedType: WidgetUtils.WidgetTypes.NONE,
      sectionID: 'section_' + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join('') + Math.random().toString().split('.').join(''),
      dragProps: {
        active: false,
        offsets: {
          move: {x: 0, y: 0},
          rotation: {x: 0, y: 0},
          resizer: {x: 0, y: 0}
        }
      },
      sizeProps: {
        active: false,
        offsets: {
          move: {x: 0, y: 0},
          rotation: {x: 0, y: 0},
          resizer: {x: 0, y: 0}
        }
      },
      currentElement: '',
      parentSection: null
    }
  },
  methods: {
    sizeStart: function (e) {
      var self = this
      var eventParams = GeneralUtils.getMouseParams(e)
      self.$data.sizeProps.active = true
      if (e.currentTarget.parentNode.getAttribute('sindex')) {
        var sectionIndex = e.currentTarget.parentNode.getAttribute('sindex')
        self.$data.parentSection = self.sections[sectionIndex]
        self.$data.currentElement = e.currentTarget.parentNode.getAttribute('id')
        self.$data.selectedWidget = self.sections[sectionIndex].widgets[Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))]
        self.$data.selectedSidgetIndex = Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))
      } else {
        self.$data.parentSection = self.section
        self.$data.currentElement = e.currentTarget.parentNode.getAttribute('id')
        self.$data.selectedWidget = self.section.widgets[Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))]
        self.$data.selectedSidgetIndex = Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))
      }
      self.$data.sizeProps.offsets.move.x = eventParams.x
      self.$data.sizeProps.offsets.move.y = eventParams.y
    },
    dragStart: function (e) {
      var self = this
      var eventParams = GeneralUtils.getMouseParams(e)
      var center = {}
      // console.log(e.currentTarget.parentNode.getAttribute('windex'))
      if (e.currentTarget.parentNode.getAttribute('sindex')) {
        var sectionIndex = e.currentTarget.parentNode.getAttribute('sindex')
        self.$data.parentSection = self.sections[sectionIndex]
        self.$data.currentElement = e.currentTarget.parentNode.getAttribute('id')
        self.$data.selectedWidget = self.sections[sectionIndex].widgets[Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))]
        self.$data.selectedSidgetIndex = Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))
        center = GeneralUtils.getElementCenter(document.getElementById(self.$data.currentElement))
      } else {
        self.$data.parentSection = self.section
        self.$data.currentElement = e.currentTarget.parentNode.getAttribute('id')
        self.$data.selectedWidget = self.section.widgets[Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))]
        self.$data.selectedSidgetIndex = Number(document.getElementById(self.$data.currentElement).getAttribute('windex'))
        center = GeneralUtils.getElementCenter(document.getElementById(self.$data.currentElement))
      }
      self.$data.dragProps.offsets.move.x = eventParams.x - center.x
      self.$data.dragProps.offsets.move.y = eventParams.y - center.y
      self.$data.dragProps.active = true
      // self.$data.currentElement = e.currentTarget.getAttribute('id')
    },
    dragEnd: function (e) {
      var self = this
      self.$data.dragProps.active = false
      self.$data.sizeProps.active = false
      self.$data.currentElement = ''
    },
    dragMove: function (e) {
      var self = this
      var eventParams = GeneralUtils.getMouseParams(e)
      var leftPrefix = self.$data.selectedWidget.properties['mleft'] !== undefined && GeneralUtils.isMobile() ? 'm' : ''
      var topPrefix = self.$data.selectedWidget.properties['mtop'] !== undefined && GeneralUtils.isMobile() ? 'm' : ''
      var widthPrefix = self.$data.selectedWidget.properties['mwidth'] !== undefined && GeneralUtils.isMobile() ? 'm' : ''
      var heightPrefix = self.$data.selectedWidget.properties['mheight'] !== undefined && GeneralUtils.isMobile() ? 'm' : ''
      if (self.$data.dragProps.active) {
        var pos = {y: eventParams.y - self.$data.dragProps.offsets.move.y - document.getElementById(self.$data.sectionID).getBoundingClientRect().top - (document.getElementById(self.$data.currentElement).getBoundingClientRect().height / 2), x: eventParams.x - self.$data.dragProps.offsets.move.x - document.getElementById(self.$data.sectionID).getBoundingClientRect().left - (document.getElementById(self.$data.currentElement).getBoundingClientRect().width / 2)}
        if (self.$data.afterTransition && GeneralUtils.isMobile()) {
          if (self.$data.selectedWidget.transition.values.top) {
            self.$data.selectedWidget.transition.values.top = pos.y
          } else {
            self.$data.selectedWidget.properties[topPrefix + 'top'] = pos.y
          }
          if (self.$data.selectedWidget.transition.values.left) {
            self.$data.selectedWidget.transition.values.left = pos.x
          } else {
            self.$data.selectedWidget.properties[topPrefix + 'left'] = pos.x
          }
        } else {
          self.$data.selectedWidget.properties[topPrefix + 'top'] = pos.y
          self.$data.selectedWidget.properties[topPrefix + 'left'] = pos.x
        }
      } else if (self.$data.sizeProps.active) {
        var dims = {width: eventParams.x - document.getElementById(self.$data.currentElement).getBoundingClientRect().left, height: eventParams.y - document.getElementById(self.$data.currentElement).getBoundingClientRect().top}
        // var pos = {y: eventParams.y - self.$data.dragProps.offsets.move.y - document.getElementById(self.$data.sectionID).getBoundingClientRect().top - (document.getElementById(self.$data.currentElement).getBoundingClientRect().height / 2), x: eventParams.x - self.$data.dragProps.offsets.move.x - document.getElementById(self.$data.sectionID).getBoundingClientRect().left - (document.getElementById(self.$data.currentElement).getBoundingClientRect().width / 2)}
        if (self.$data.afterTransition && GeneralUtils.isMobile()) {
          if (self.$data.selectedWidget.transition.values.width) {
            self.$data.selectedWidget.transition.values.width = dims.width
          } else {
            self.$data.selectedWidget.properties[topPrefix + 'width'] = dims.width
          }
          if (self.$data.selectedWidget.transition.values.height) {
            self.$data.selectedWidget.transition.values.height = dims.height
          } else {
            self.$data.selectedWidget.properties[topPrefix + 'height'] = dims.height
          }
        } else {
          self.$data.selectedWidget.properties[topPrefix + 'width'] = dims.width
          self.$data.selectedWidget.properties[topPrefix + 'height'] = dims.height
        }
      }
    },
    getBackgroundStyle: function () {
      var self = this
      return 'background-color:' + self.section.background.color + ';background-image:url(' + self.section.background.image.url + '); background-position:' + self.section.background.image.position + '; background-size: ' + self.section.background.image.size + '; background-repeat: ' + self.section.background.image.repeat + ';'
    },
    getWidgetShellStyle: function (w, after, index) {
      var self = this
      var width = self.getWidgetProperty(w, 'width', after, index)
      var height = self.getWidgetProperty(w, 'height', after, index)
      var left = self.getWidgetProperty(w, 'left', after, index)
      var top = self.getWidgetProperty(w, 'top', after, index)
      var rotation = self.getWidgetProperty(w, 'rotation', after, index)
      var rotationString = rotation ? 'rotate(' + rotation.toString() + 'deg);' : ''
      // var opacity = self.getWidgetProperty(w, 'opacity', after, index)
      return 'width:' + width.toString() + 'px;height:' + height.toString() + 'px;left:' + left.toString() + 'px;top:' + top.toString() + 'px;transform:' + rotationString
    },
    getWidgetProperty: function (w, property, after, index) {
      var self = this
      var val = null
      var prefix = w.properties['m' + property] !== undefined && GeneralUtils.isMobile() ? 'm' : ''
      if (index !== undefined && index !== null) {
        // console.log(w.transition.length)
        // console.log(index)
        val = after && w.transition[index].values[property] && !self.section.shared ? w.transition[index].values[property] : w.properties[prefix + property]
      } else {
        val = after && w.transition.values[property] && !self.section.shared ? w.transition.values[property] : w.properties[prefix + property]
      }
      return val
    },
    saveClicked: function (e) {
      var self = this
      EventBus.$emit('section-save', {index: self.index, section: self.section})
    },
    addWidgetClicked: function (e) {
      var self = this
      self.$data.showAddWindow = true
    }
  },
  mounted: function () {
    var self = this
    EventBus.$on('modal-window-cancel', (n) => {
      switch (n.sig) {
        case GeneralUtils.Modals.ADD_WIDGET:
        {
          self.$data.showAddWindow = false
          break
        }
      }
    })
    EventBus.$on('modal-window-ok', (n) => {
      switch (n.sig) {
        case GeneralUtils.Modals.ADD_WIDGET:
        {
          if (self.$data.selectedType !== WidgetUtils.WidgetTypes.NONE) {
            EventBus.$emit('section-widget-added', {index: self.index, type: self.$data.selectedType})
            self.$data.showAddWindow = false
          } else {
            alert('You must select a widget type.')
          }
          break
        }
      }
    })
    EventBus.$on('delete-widget', (n) => {
      // console.log('delete clicked')
      self.section.widgets.splice(self.$data.selectedSidgetIndex, 1)
      self.$data.selectedSidgetIndex = -1
      self.$data.selectedWidget = null
      // self.$forceUpdate()
    })
  }
  // title: 'What',
  //         shouldRender: false,
  //         shared: false,
  //         background: {
  //           color: '#ffffff',
  //           image: {
  //             url: 'src/assets/slide1BG.jpg',
  //             size: 'cover',
  //             position: 'center',
  //             repeat: 'no-repeat'
  //           }
  //         },
}
</script>
<style lang="scss" scoped>
div.section-view{
  position: fixed;
  left:0;
  top:0;
  right:0;
  bottom:0;
  > div:not(.modal-window-component) {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 1200px;
    height: 0;
    margin-left: -600px;
    margin-top: -300px;
    > div {
      position:absolute;
    }
  }
  > div.section-details{
    position:fixed !important;
    right: 0 !important;
    top:0 !important;
    bottom:45px !important;
    width: 250px !important;
    overflow-y: auto !important;
    height:auto !important;
    margin-left:0 !important;
    left:auto !important;
    margin-top:0 !important;
    background-color:rgba(255,255,255,.6);
  }
}
div.widget-container{
  box-shadow: 0 0 0 1px #333333, 0 0 0 2px #ffffff;
  > div{
    width: 100%;
    height: 100%;
    > div, img{
      width: 100%;
      height: 100%;
    }
  }
  > div.widget-sizer{
    width: 12px;
    height: 12px;
    right: -6px;
    bottom: -6px;
    position: absolute;
    display:inline-block;
    background-color:#00cc00;
    z-index:10;
  }
}
span.util-nav{
  position: fixed;
  bottom: 0;
  right: 0;
  display: block;
  background-color: rgba(235,235,235,.8);
  padding: 5px;
  left: 0px;
  text-align: right;
}
div.editor-drag-overlay{
  width: 100%;
  height: 100%;
  position: absolute;
  top:0;
  left:0;
}
</style>



// WEBPACK FOOTER //
// src/components/editors/Section.vue